<div class="card facilityCard p-3 mt-1" [class.bg-info-30]="facility.id == primaryFacilityId">
	<div class="row mr-0 ml-0 align-items-center">
		<!-- Column 1: Name and IDs -->
		<div class="col-sm-12 col-lg-5 px-0 mb-3">
			<h5 class="card-title mb-1">{{ facility.name }}</h5>
			<h6 class="card-subtitle mb-2 text-muted" style="font-size: 12px">
				{{ facility.company_name }}
				<span class="ms-2">
					{{ facility.id == primaryFacilityId ? '(Primary)' : '' }}
				</span>
			</h6>
			<div class="mt-2" style="font-size: 13px;">
				<div><b>Account ID:</b> {{facility.company_id }}-{{ facility.id }}</div>
				<div *ngIf="facility.dea_number && featureFlagsService.getByEnv('ui','DEA')">
					<b>DEA:</b> {{ facility.dea_number }}
				</div>
			</div>
		</div>
		<!-- Column 2: Address -->
		<div class="col-sm-12 col-lg-3 px-0 mb-3">
			<div class="text-muted mb-1" style="font-size: 12px;"><b>Shipping To:</b></div>
			<div style="font-size: 13px;">
				{{ facility.address_line_1 | titlecase }}<br />
				<div *ngIf="facility.address_line_2">
					{{ facility.address_line_2 | titlecase }}
				</div>
				<div *ngIf="facility.address_line_3">
					{{ facility.address_line_3 | titlecase }}
				</div>
				{{ facility.address_city | titlecase }},
				{{ facility.address_state }},
				{{ facility.address_postal_code }}
			</div>
		</div>
		<!-- Column 3: Warnings -->
		<div class="col-sm-12 col-lg-2 px-0 mb-3 text-right d-flex flex-wrap">
			<div *ngIf="!facility.vetted" class="mr-2">
				<div id="vetting-alert-{{ facility.id }}" class="alert-icon vetting-icon">
					<i class="dx-icon-warning"></i>
				</div>
				<app-ms-tooltip [target]="'vetting-alert-' + facility.id" width="300"
					tooltipText="This facility is not yet vetted. This normally applies to newly registered accounts. Vetting normally takes 1-2 business days assuming valid account information and license."></app-ms-tooltip>
			</div>
			<div *ngIf="facility.user_count === 0" class="mr-2">
				<div id="user-count-alert-{{ facility.id }}" class="alert-icon user-count-icon">
					<i class="dx-icon-user"></i>
				</div>
				<app-ms-tooltip [target]="'user-count-alert-' + facility.id" width="300"
					tooltipText="There are no users set up on this account. Please find email addresses of the account principals and contact <a href='mailto:customersupport@letybousa.com'>customersupport@letybousa.com</a> with this information so we can complete the account setup."></app-ms-tooltip>
			</div>
			<div *ngIf="status.expiredMessage" class="mr-2">
				<div id="expired-alert-{{ facility.id }}" class="alert-icon expired-icon">
					<i class="dx-icon-event"></i>
				</div>
				<app-ms-tooltip [target]="'expired-alert-' + facility.id" width="300"
					[tooltipText]="status.expiredMessage"></app-ms-tooltip>
			</div>
			<div *ngIf="facility.require_terms_agreement" class="mr-2">
				<div id="require-terms-{{ facility.id }}" class="alert-icon expired-icon">
					<i class="dx-icon-file"></i>
				</div>
				<app-ms-tooltip [target]="'require-terms-' + facility.id" width="300"
					tooltipText="Customer not agreed to terms / activated their portal account."></app-ms-tooltip>
			</div>
		</div>
		<!-- Column 4: Action Button -->
		<div class="col-sm-12 col-lg-2 px-0 text-right">
			<div *ngIf="facility.id != primaryFacilityId && facility.vetted && facility.user_count > 0">
				<dx-button type="default" stylingMode="outlined" text="Select Facility"
					(onClick)="onSwitch()"></dx-button>
			</div>
		</div>
	</div>
</div>